import { useState } from "react"
import { toast } from "sonner"
import { useApplicants } from "./useApplicants"

interface StartAiScreeningCallArgs {
  applicationId: string
  phoneNumber?: string | null
  onPhoneRequired: () => void
  onSuccess?: () => Promise<void> | void
}

export function useAiScreeningCall() {
  const { createInterview } = useApplicants()
  const [isStarting, setIsStarting] = useState(false)

  const startAiScreeningCall = async ({
    applicationId,
    phoneNumber,
    onPhoneRequired,
    onSuccess,
  }: StartAiScreeningCallArgs) => {
    if (!applicationId) return

    if (!import.meta.env.PROD && !phoneNumber) {
      onPhoneRequired()
      return
    }

    setIsStarting(true)
    try {
      await toast.promise(createInterview(applicationId), {
        loading: "Creating AI Screening...",
        success: "AI Screening created successfully",
        error: (err) =>
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Failed to create AI Screening",
      })

      await onSuccess?.()
    } finally {
      setIsStarting(false)
    }
  }

  return { startAiScreeningCall, isStarting }
}
